type MatrixRtcMembershipIdentity = {
    deviceId?: string;
    sender?: string;
};

export const getMatrixRtcParticipantUserId = (
    memberships: MatrixRtcMembershipIdentity[],
    identity: string
): string => {
    const membership = memberships.find(item => `${item.sender}:${item.deviceId}` === identity);
    if (membership?.sender) {
        return membership.sender;
    }

    const separatorIndex = identity.lastIndexOf(":");
    return separatorIndex > 0 ? identity.slice(0, separatorIndex) : identity;
};

export const isCurrentMatrixRtcParticipant = (
    memberships: MatrixRtcMembershipIdentity[],
    identity: string,
    currentUserId: string
): boolean => {
    return Boolean(currentUserId) && getMatrixRtcParticipantUserId(memberships, identity) === currentUserId;
};
